import { S } from '../app/app_state.js?v=20260817c';

/**
 * Rendert render Coordinate Axis Overlay im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt Hilfslogik.
 * - Kapselt Darstellung im Plan, Layer-Aufbau oder grafische Markierung, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function renderCoordinateAxisOverlay() {
  const wrap = document.getElementById('canvasWrap');
  if (!wrap) return null;
  let overlay = document.getElementById('coordinateAxisOverlay');
  if (S?.ui?.showCoordinateAxis === false) {
    overlay?.remove();
    return null;
  }
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'coordinateAxisOverlay';
    overlay.className = 'coordinate-axis-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = coordinateAxisOverlaySvg();
    wrap.appendChild(overlay);
  }
  overlay.dataset.view = 'plan';
  return overlay;
}

/**
 * Beschreibt coordinate Axis Overlay Svg im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt Hilfslogik.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function coordinateAxisOverlaySvg() {
  return `
    <svg viewBox="0 0 96 96" focusable="false">
      <defs>
        <marker id="axisArrowX" viewBox="0 0 10 10" refX="8.5" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#dc2626"></path>
        </marker>
        <marker id="axisArrowY" viewBox="0 0 10 10" refX="8.5" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#16a34a"></path>
        </marker>
        <marker id="axisArrowZ" viewBox="0 0 10 10" refX="8.5" refY="5" markerWidth="5" markerHeight="5" orient="auto">
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#2563eb"></path>
        </marker>
      </defs>
      <path class="coordinate-axis-plane" d="M 24 72 L 72 72 L 78 66 L 30 66 Z"></path>
      <line class="coordinate-axis-line z" x1="24" y1="72" x2="43" y2="52" marker-end="url(#axisArrowZ)"></line>
      <line class="coordinate-axis-line x" x1="24" y1="72" x2="76" y2="72" marker-end="url(#axisArrowX)"></line>
      <line class="coordinate-axis-line y" x1="24" y1="72" x2="24" y2="20" marker-end="url(#axisArrowY)"></line>
      <circle class="coordinate-axis-origin" cx="24" cy="72" r="4"></circle>
      <text class="coordinate-axis-label x" x="82" y="77" text-anchor="middle">X</text>
      <text class="coordinate-axis-label y" x="24" y="15" text-anchor="middle">Y</text>
      <text class="coordinate-axis-label z" x="48" y="50" text-anchor="start">Z</text>
    </svg>
  `;
}

export {
  renderCoordinateAxisOverlay,
  coordinateAxisOverlaySvg
};
